import { styled } from '@mui/system'
import { Button } from '@mui/material'

/* eslint-disable no-undef, no-unused-vars, no-empty-pattern */

export const UserMainPage = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 'calc(100vh - 5rem - 5rem)',
}))

export const UserPanel = styled('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  minHeight: '400px',
  minWidth: '600px',
}))

export const UserButton = styled(Button)(({ theme }) => ({
  boxShadow: 'none',
  width: 200,
  margin: 10,
  background: theme.palette.primary.main,
  color: 'white',
  '&:hover': {
    background: theme.palette.primary.dark,
  },
}))
